export default "__VITE_ASSET__dbd4b35f__"